import { LoyaltyRewardGetDto } from "clearline-api";

export class LoyaltyCardUser {
  public activeRewards?: LoyaltyRewardGetDto[];
  public id: string;
  public firstName: string;
  public profilePicture: string;
  public gender: string;
  public phone: string;
  public email: string;
  public stamps: number;
  public points: number;
  public lastName: string;
  public uniqueCode: string;
}
